import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class TemplateStyleChangedMessage extends Message {

    public style: any;

    public constructor(params: any) {
        super(params);

        this.style = params.style;
    }
}

ComponentManager.setMessage('TemplateStyleChangedMessage', TemplateStyleChangedMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');